import setupAxios from './Base'
const prefix = '/_api_'
export default class Account {
  constructor(token) {
    this.axios = setupAxios({
      authorization: `Bearer ${token.token}`,
      cache: true,
      wedId: token.token_payload.wed_id,
    })
  }

  getGiftsAmountToReceive(wed) {
    return this.axios.get(`${prefix}/getGiftsAmountToReceive?wed=${wed}`, {
      id: 'gifts-amount-to-receive',
    })
  }

  getInfoWedding(wed) {
    return this.axios.get(`${prefix}/getWedsiteInfo?wed=${wed}`, {
      id: 'wedsite-info',
      cache: false,
    })
  }

  getTokenExtra(data) {
    return this.axios.post(`/logon/loginExternalIntegration`, data)
  }

  getNewRepassTimeEnabled(wed) {
    return this.axios.get(`${prefix}/getEnableNewTimeRepass?wed=${wed}`)
  }
}
